import Model from '@/entities/Model.js';
import type { User } from '@/entities/types/LeadType.ts';

export type ConversationStoreUser = Pick<
    User,
    'id' | 'first_name' | 'last_name' | 'role_id' | 'profile_picture' | 'active'
>;

export default class ConversationDisplayUser extends Model {
    private static readonly DEFAULT_AVATAR = '/img/nobody.jpg';

    declare id: number;

    declare firstName: string;

    declare lastName: string;

    declare roleId: number | null;

    declare avatarUrl: string | null;

    declare active: boolean;

    static get defaults() {
        return {
            id: 0,
            firstName: '',
            lastName: '',
            roleId: null,
            avatarUrl: null,
            active: true,
        };
    }

    static createPlaceholder(id: number, unknownUserLabel: string): ConversationDisplayUser {
        return new ConversationDisplayUser({
            id,
            firstName: unknownUserLabel,
            lastName: '',
            roleId: null,
            avatarUrl: null,
            active: false,
        });
    }

    static fromStoreUser(user: ConversationStoreUser): ConversationDisplayUser {
        const hasRealAvatar =
            user.profile_picture && user.profile_picture !== ConversationDisplayUser.DEFAULT_AVATAR;

        return new ConversationDisplayUser({
            id: user.id,
            firstName: user.first_name,
            lastName: user.last_name,
            roleId: user.role_id,
            avatarUrl: hasRealAvatar ? user.profile_picture : null,
            active: user.active,
        });
    }

    get fullName(): string {
        return `${this.firstName} ${this.lastName}`.trim();
    }

    constructor(initialValues: Partial<ConversationDisplayUser> = {}) {
        super(initialValues);
    }
}
